import React from "react";

export const markdownToJSX = (markdownText) => {
  if (!markdownText) return <></>;

  const lines = markdownText.split(/(?:\\n|\n)/).map((line) => line.trim());

  const elements = [];
  let listStack = [];

  // Function to format text for bold and italic
  const formatText = (text) => {
    return text.split(/(\*\*.*?\*\*|\*.*?\*)/).map((part, i) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return <strong key={i}>{part.slice(2, -2)}</strong>;
      }
      if (part.startsWith("*") && part.endsWith("*")) {
        return <em key={i}>{part.slice(1, -1)}</em>;
      }
      return part;
    });
  };

  // Function to close any open lists
  const closeList = () => {
    while (listStack.length > 0) {
      elements.push(listStack.pop().list);
    }
  };

  // Function to handle list items
  const handleListItem = (line, index) => {
    const unorderedMatch = line.match(/^[-*]\s+(.*)/);
    if (unorderedMatch) {
      const content = unorderedMatch[1];
      const listItem = (
        <li key={index} style={{ marginLeft: "20px" }}>
          {formatText(content)}
        </li>
      );
      if (listStack.length === 0) {
        closeList();
        const newList = (
          <ul key={`ul-${index}`} style={{ paddingLeft: "1rem" }}>
            {listItem}
          </ul>
        );
        listStack.push({ list: newList, items: [listItem] });
      } else {
        listStack[listStack.length - 1].items.push(listItem);
        listStack[listStack.length - 1].list = React.cloneElement(
          listStack[listStack.length - 1].list,
          {},
          listStack[listStack.length - 1].items
        );
      }
      return true; // Indicates the line was handled as a list item
    }
    return false; // No list item match
  };

  // Process each line of markdown
  lines.forEach((line, index) => {
    if (!line) {
      closeList();
      return; // Skip empty lines
    }
    if (line === "") {
      closeList();
      return; // Skip empty lines
    }

    // Handle unordered list items
    if (handleListItem(line, index)) return;

    // Close any open lists if the line is not a list item
    closeList();

    // Check for headers or other markdown syntax
    const headerMatch = line.match(/^(#{1,5})\s+(.*)/);
    if (headerMatch) {
      const level = headerMatch[1].length;
      const content = headerMatch[2];
      const Tag = `h${level}`;
      elements.push(<Tag key={index}>{formatText(content)}</Tag>);
      return;
    }

    // Check for a line that is entirely **bold**
    const boldMatch = line.match(/^\*\*(.+)\*\*$/);
    if (boldMatch) {
      elements.push(<h3 key={index}>{formatText(boldMatch[1])}</h3>);
      return;
    }

    // Default: treat the line as a paragraph
    elements.push(<p key={index}>{formatText(line)}</p>);
  });

  closeList(); // Close any lists that might remain open
  return <>{elements}</>;
};
